export default "__VITE_ASSET__BYCYXAVA__"